import Store from './store';

export default {
	Store
};


// WEBPACK FOOTER //
// ./store/index.js